import {observable} from 'mobx'

export default class MarketCoupon {
    @observable coupon_id = 0
    @observable is_enabled = false
    @observable description = ''
    @observable url = ''

    constructor(coupon) {
        if (coupon) {
            this.coupon_id = parseInt(coupon.coupon_id)
            this.is_enabled = coupon.is_enabled
            this.description = coupon.description
            this.url = coupon.url
        }
    }
}